export default __webpack_public_path__ + "static/media/tick_icon.7d827122.svg";